<template>
  <div>
    <va-modal
      ref="appointmentInfoModal"
      id="appointmentInfoModal"
      :size="'medium'"
      :value="showModal"
      :noOutsideDismiss="false"
      :okText="$t('modals.buttons.init')"
      :cancelText="$t('modals.buttons.cancel')"
      :hideDefaultActions="true"
      :fixedLayout="true"
      @cancel="cancel">

      <div slot="header" class="d-flex flex-column align-items-start">
        <span class="modal-title mb-0">{{ $t('evocall.appointment.details') }}</span>
        <span
          v-if="appointmentIsActive"
          class="is-bold text-orange">
          {{ $t('evocall.appointment.active_appointment_message') }}
      </span>
        <!--<small v-if="isNotCallRequestAppointment && activeAppointment !== null && !appointmentIsActive && appointmentIsToday" class="text-danger">
          <span>
            <i class="fa fa-exclamation-circle"></i>
            {{$t('clinical.appointments.has_active_appointment', {person: activeAppointment.person.name, start: $options.filters.localTime(activeAppointment.start, 'DD/MM/YYYY HH:mm'), end:$options.filters.localTime(activeAppointment.end, 'DD/MM/YYYY HH:mm')})}}
          </span>
        </small>-->
      </div>

      <div class="modal-header-actions d-flex justify-content-end" :class="{'with-warning': isNotCallRequestAppointment && !appointmentIsActive && appointmentIsToday}">
        <va-popover
          v-if="userCanEditAppointment || userCanUpdateInactiveAppointment"
          placement="left"
          :message="$t('clinical.buttons.update_appointment')">
          <va-button
            v-if="!appointmentIsActive"
            large
            class="va-button-rounded"
            icon="fa fa-pencil"
            color="gray"
            @click="edit">
          </va-button>
        </va-popover>

        <va-popover
          v-if="userCanStartAppointment && appointment.started_at !== null && (appointment.ended_at === null || appointmentHasRecentlyEnded) "
          placement="left"
          :message="$t('clinical.buttons.resume_appointment')"
        >
          <span class="i-appointment-start" @click="start"></span>
        </va-popover>

        <va-popover
          v-if="userCanReopenAppointment "
          placement="left"
          :message="$t('clinical.buttons.reopen_appointment')"
        >
          <span class="i-appointment-start" @click="reopenAppointment"></span>
        </va-popover>

        <!--v-if="userCanStartAppointment && appointment.started_at === null && activeAppointment === null && appointmentIsToday"-->
        <va-popover
          v-if="userCanStartAppointment && appointment.started_at === null && appointmentIsToday"
          placement="left"
          :message="$t('clinical.buttons.start_appointment')"
        >
          <span class="i-appointment-later" @click="openConfirmStartModal"></span>
        </va-popover>

        <va-popover
          placement="left"
          :message="$t('clinical.buttons.check_details')"
          v-if="userCanViewAppointment && appointment.ended_at !== null">
          <span class="i-appointment-ended" @click="openDetails"></span>
        </va-popover>

        <va-popover
          placement="left"
          :message="$t('clinical.appointments.appointment_missed')"
          v-if="appointmentIsPast && appointment.started_at === null"
        >
          <span class="i-appointment-missed"></span>
        </va-popover>

      </div>

      <AppointmentInfo
        v-if="appointment"
        :appointment="appointment"
        :serviceSlug="service.slug"
        @closeAppointmentDetailsModal="handleCloseAppointmentDetailsModal"
      />

    </va-modal>

    <AppointmentForm
      v-if="showAppointmentForm"
      :appointment="appointment"
      :facilities="facilities"
      :service="service"
      @modal-closed="modalClosed"
      @appointment-updated="appointmentUpdated"
      @appointment-deleted="appointmentDeleted" />

    <ConfirmationModal
      v-if="showConfirmStartAppointmentModal"
      :title="$t('clinical.appointment.start_confirm_title')"
      :body="$t('clinical.appointment.start_confirm_body', {patient: this.appointment.person.name, startDate: this.moment(this.appointment.start).format('YYYY-MM-DD'), startTime: this.moment(this.appointment.start).format('HH:mm')})"
      @modal-canceled="closeStartAppointmentConfirmModal"
      @modal-confirmed="confirmStartAppointmentConfirmModal"
    />

  </div>
</template>
<script>
import { ActivityService } from '@/api/AuthService'
import { mapState } from 'vuex'
import AppointmentForm from './AppointmentForm'
import { AppointmentService } from '@/api/AuthClinicalService'
import AppointmentInfo from '@/components/clinical/appointments/AppointmentInfo'
import ConfirmationModal from '@/components/common/ConfirmationModal'
const ReadAccessType = 1
const WriteAccessType = 2
const AppointmentInfoType = 200
const AppointmentDetailsInfoType = 300
const DispenserFieldId = 8
const DispenserPremisesId = 9
const Audiology = 1

export default {
  components: {
    ConfirmationModal,
    AppointmentForm,
    AppointmentInfo
  },
  props: {
    appointment: {
      type: Object,
      required: true
    },
    readEntityActivityUsers: {
      type: Array,
      required: false
    },
    writeEntityActivityUsers: {
      type: Array,
      required: false
    },
    service: {
      type: Object,
      required: true
    },
    inactiveEntityActivityUsers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      entityActivityUsersRead: this.readEntityActivityUsers,
      entityActivityUsersWrite: this.writeEntityActivityUsers,
      showModal: false,
      showAppointmentForm: false,
      showConfirmStartAppointmentModal: false,
      facilities: []
    }
  },
  created () {
    if (!this.entityActivityUsersRead) {
      this.loadEntityActivityUsersRead()
    }
    if (!this.entityActivityUsersWrite) {
      this.loadEntityActivityUsersWrite()
    }
  },
  mounted () {
    this.showModal = true
    if (this.appointment.hasOwnProperty('facility')) {
      this.facilities.push(this.appointment.facility)
    }
  },
  methods: {
    handleCloseAppointmentDetailsModal: function () {
      this.showModal = false
    },
    loadEntityActivityUsersRead: function () {
      let params = {
        ...this.getDefaultEntityActivityUsersParams,
        accessType: ReadAccessType
      }
      ActivityService.getActivityUsersByEntity(params)
        .then(entityActivityUsers => {
          this.entityActivityUsersRead = entityActivityUsers
        }).catch(errors => {
          console.log(errors)
        })
    },
    loadEntityActivityUsersWrite: function () {
      let params = {
        ...this.getDefaultEntityActivityUsersParams,
        infoType: AppointmentInfoType,
        accessType: WriteAccessType
      }
      ActivityService.getActivityUsersByEntity(params)
        .then(entityActivityUsers => {
          this.entityActivityUsersWrite = entityActivityUsers
        }).catch(errors => {
          console.log(errors)
        })
    },
    openDetails: function () {
      this.$refs.appointmentInfoModal.cancel()
      this.$router.push({ name: `${this.service.slug}clinical/appointments/:id/anamnesis`, params: { id: this.appointment.id } })
    },
    appointmentUpdated: function ({ appointment }) {
      this.$emit('appointment-updated', { appointment })
      this.showAppointmentForm = false
      this.showModal = true
    },
    appointmentDeleted: function ({ appointment }) {
      this.$emit('appointment-deleted', { appointment })
    },
    cancel: function () {
      this.$emit('modal-closed')
    },
    openConfirmStartModal: function () {
      this.showConfirmStartAppointmentModal = true
      this.showModal = false
    },
    closeStartAppointmentConfirmModal: function () {
      this.showConfirmStartAppointmentModal = false
      this.showModal = true
    },
    confirmStartAppointmentConfirmModal: function () {
      this.showConfirmStartAppointmentModal = false
      this.start()
    },
    start: function () {
      AppointmentService.start(this.service.url, this.appointment.id)
        .then(appointment => {
          this.$refs.appointmentInfoModal.cancel()
          this.$router.push({ name: `${this.service.slug}clinical/appointments/:id/anamnesis/edit`, params: { id: this.appointment.id } })
        }).catch(errors => {
          console.log(errors)
        })
    },
    reopenAppointment: function () {
      AppointmentService.reopen(this.service.url, this.appointment.id)
        .then(appointment => {
          if (appointment) {
            this.$refs.appointmentInfoModal.cancel()
            this.showToast(this.$t('clinical.appointments.reopened_successfully'), this.$store.state.successToastOptions)
            this.$emit('appointment-reopened')
          } else {
            this.showToast(this.$t('clinical.appointments.something_went_wrong'), this.$store.state.errorToastOptions)
          }
        }).catch(errors => {
          console.log(errors)
          this.showToast(this.$t('clinical.appointments.something_went_wrong'), this.$store.state.errorToastOptions)
        })
    },
    edit: function () {
      this.showModal = false
      this.showAppointmentForm = true
    },
    modalClosed: function () {
      this.showAppointmentForm = false
      this.showModal = true
    }
  },
  computed: {
    userCanUpdateInactiveAppointment: function () {
      if (this.inactiveEntityActivityUsers.length) {
        return this.inactiveEntityActivityUsers.some(eau => eau.id === this.appointment.entity_activity_user_id) && (this.$auth.user().id === this.appointment.user.id || this.service.user_permissions.some(perm => perm.access_type > 2 && perm.info_type === 200))
      }
      return false
    },
    userCanReopenAppointment: function () {
      return this.appointment.started_at !== null && this.appointment.ended_at !== null && !this.appointmentHasRecentlyEnded && this.service.user_permissions.some(perm => perm.access_type > 2 && perm.info_type === 200)
    },

    authClinicalService: function () {
      return this.service
    },
    waitingRoomModuleKey: function () {
      return `waiting-room-${this.service.slug}`
    },
    ...mapState({
      activeAppointments (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/activeAppointments`] || null
      }
    }),
    getDefaultEntityActivityUsersParams () {
      return {
        inclusive: false,
        activities: `${DispenserFieldId},${DispenserPremisesId},${Audiology}`,
        infoType: AppointmentDetailsInfoType,
        serviceId: this.service.id,
        start: this.$options.filters.utcTime(this.appointment.start),
        end: this.$options.filters.utcTime(this.appointment.end)
      }
    },
    appointmentIsToday: function () {
      if (this.appointment && this.appointment.start !== null) {
        return this.moment(this.appointment.start).isSame(new Date(), 'day')
      }
      return false
    },
    appointmentStartIsPast: function () {
      if (this.appointment && this.appointment.start !== null) {
        return this.moment(this.appointment.start).isBefore(this.moment())
      }
      return false
    },
    appointmentIsPast: function () {
      if (this.appointment && this.appointment.start !== null) {
        return this.moment(this.appointment.start).isBefore(new Date(), 'day')
      }
      return false
    },
    appointmentIsFuture: function () {
      if (this.appointment && this.appointment.start !== null) {
        return this.moment(this.appointment.start).isAfter()
      }
      return false
    },
    appointmentHasRecentlyEnded: function () {
      if (this.appointment && this.appointment.ended_at !== null) {
        return this.moment(this.appointment.ended_at).isAfter(this.moment().subtract(24, 'hours'))
      }
      return false
    },
    hasWriteAppointmentPermissions: function () {
      return this.service.user_permissions.some(p => p.info_type === AppointmentInfoType && p.access_type >= WriteAccessType && (p.entity_id === null || p.entity_id === this.appointment.entity.id))
    },
    hasWriteAppointmentDetailsPermissions: function () {
      return this.service.user_permissions.some(p => p.info_type === AppointmentDetailsInfoType && p.access_type >= WriteAccessType && (p.entity_id === null || p.entity_id === this.appointment.entity.id))
    },
    hasReadAppointmentDetailsPermissions: function () {
      return this.service.user_permissions.some(p => p.info_type === AppointmentDetailsInfoType && p.access_type >= ReadAccessType && (p.entity_id === null || p.entity_id === this.appointment.entity.id))
    },
    userCanStartAppointment: function () {
      return this.userCanEditAppointment && this.appointment.user && this.appointment.user.id === this.$auth.user().id && this.hasWriteAppointmentDetailsPermissions
    },
    userCanViewAppointment: function () {
      if (Array.isArray(this.entityActivityUsersRead) && this.entityActivityUsersRead.length > 0) {
        console.log(this.entityActivityUsersRead.some(entityActivityUser => entityActivityUser.id === this.appointment.entity_activity_user_id) && this.hasReadAppointmentDetailsPermissions)
        return this.entityActivityUsersRead.some(entityActivityUser => entityActivityUser.id === this.appointment.entity_activity_user_id) && this.hasReadAppointmentDetailsPermissions
      }
      return false
    },
    userCanEditAppointment: function () {
      if (Array.isArray(this.entityActivityUsersWrite) && this.entityActivityUsersWrite.length > 0 && this.appointment.parent_id === null && (this.hasWriteAppointmentPermissions || this.hasWriteAppointmentDetailsPermissions)) {
        return this.appointment.user === null ? true : this.entityActivityUsersWrite.some(entityActivityUser => entityActivityUser.id === this.appointment.entity_activity_user_id)
      }
      return false
    },
    appointmentIsActive: function () {
      return this.appointment !== null &&
      (this.appointment.started_at !== null && this.moment(this.appointment.started_at).isBefore(this.moment())) &&
      (this.appointment.ended_at === null || (this.appointment.ended_at !== null && this.moment(this.appointment.ended_at).isAfter(this.moment())))
    },
    isNotCallRequestAppointment: function () {
      return this.appointment.parent_id === null
    }
  }
}
</script>
